import Image from '@space-lib/components/image'
import NotificationError from '@space-shell/assets/images/notificationsError.svg'
import { useTranslation } from 'react-i18next'

const NotificationErrorState = () => {
  const { t } = useTranslation()

  return (
    <div className='_d-flex _flex-column _align-items-center _py-5 _px-8'>
      <Image src={NotificationError} aria-hidden />
      <p className='_text-2 _text-gray-500 _mb-0 _mt-3'>{t('notifications.error.title')}</p>
      <p className='_text-1 _text-gray-500'>{t('notifications.error.description')}</p>
    </div>
  )
}

export default NotificationErrorState
